import React, { useState } from 'react'
import { Button, Col, Form, Modal } from 'react-bootstrap'
import { toast } from 'react-toastify'
import { get } from 'src/apis/apiService'
import { AUTH_APIS } from 'src/apis/authApi'
import { ForgetPasswordModal, StyledWrapper } from './styled'

export const ForgetPassword = () => {
  const [show, setShow] = useState(false)
  const [email, setEmail] = useState('')
  const [loading, setLoading] = useState(false)

  const handleClose = () => setShow(false)

  const handleClick = (e) => {
    e.preventDefault()
    setShow(true)
  }

  const handleInput = (e) => setEmail(e.target.value.toLowerCase())

  const handleSubmit = (e) => {
    setLoading(true)
    e.preventDefault()
    get(
      AUTH_APIS.forgetPassword,
      (data) => {
        setLoading(false)
        if (data.exist) {
          toast('We have sent you the access code via email, please check your mailbox.')
          setShow(false)
          setEmail('')
        } else {
          toast('This email does not seem to be registered to our system.')
        }
      },
      (error) => {
        setLoading(false)
        toast(error.response?.data?.message)
      },
      { email }
    )
  }

  return (
    <>
      <StyledWrapper>
        <div id="btn">
          <span>Forgot Password? </span>
          <span className="highlight" role="button" onClick={handleClick}>
            Click Here
          </span>
        </div>
      </StyledWrapper>
      <ForgetPasswordModal show={show} onHide={handleClose} size="md" aria-labelledby="schedule-modal" centered>
        <Modal.Header closeButton>
          <Modal.Title>Forgot Access Code</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Row>
            <Form.Group as={Col} controlId="formGridEmail">
              <Form.Label>Enter Email to request for Access Code</Form.Label>
              <Form.Control type="email" placeholder="Enter email here..." onChange={handleInput} value={email} />
            </Form.Group>
          </Form.Row>
          <Button
            id="verify-btn"
            disabled={email.length < 4 || loading}
            className="c-button btn"
            onClick={handleSubmit}
          >
            {loading ? 'Verifying...' : 'Verify Email'}
          </Button>
        </Modal.Body>
      </ForgetPasswordModal>
    </>
  )
}
